export default [
  {
    path: "/expertsList", // 专家库
    name: "expertsList",
    component: () =>
      import(
        /* webpackChunkName: "experts" */ "../views/Experts/ExpertsList/index.vue"
      ),
    meta: {
      eventId: "W-Z-15-V1",
      eventName: "专家列表曝光",
      module: "专家智库",
    },
  },
  {
    path: "/expertsDetail", // 专家详情
    name: "expertsDetail",
    component: () =>
      import(
        /* webpackChunkName: "experts" */ "../views/Experts/ExpertsDetail/index.vue"
      ),
    meta: {
      eventId: "W-Z-16-V1",
      eventName: "专家详情曝光",
      module: "专家智库",
    },
  },
];
